export enum AdminType {
  SUPER = "SUPER",
  ADMIN = "ADMIN",
  VIEWER = "VIEWER",
}
